import React from "react";
import ReactDOM from "react-dom";
import "semantic-ui-css/semantic.min.css";
import "alertifyjs/build/css/alertify.min.css";
import "alertifyjs/build/css/themes/semantic.css";

import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { WebSocketLink } from "apollo-link-ws";
import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloProvider, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import AppContext from "./AppContext";
import Login from "./Login";
import AppCrash from "./AppCrash";

import injectStyles from "./assets/styles/style";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import {
  pink,
  red,
  lightBlue,
  deepPurple,
  blueGrey,
} from "@material-ui/core/colors";
import { Home, Companies, Persons } from "./pages";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

const theme = createMuiTheme({
  palette: {
    primary: blueGrey,
    secondary: red,
  },
});
const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      authorization: localStorage.getItem("token") || null,
    },
  });
  return forward(operation);
});

const wsLink = new WebSocketLink(
  new SubscriptionClient(process.env.REACT_APP_SUBSCRIPTION_URI, {
    reconnect: true,
  })
);

const httpLink = middlewareLink.concat(
  createHttpLink({
    uri: process.env.REACT_APP_HTTP_URI,
  })
);

const hasSubscriptionOperation = ({ query: { definitions } }) => {
  return definitions.some(
    ({ kind, operation }) =>
      kind === "OperationDefinition" && operation === "subscription"
  );
};
const cache = new InMemoryCache();

const link = ApolloLink.split(hasSubscriptionOperation, wsLink, httpLink);

const client = new ApolloClient({
  link,
  cache,
  //typeDefs, //: importSchema("./graphql/cache/types/schema.graphql")
  //resolvers,
});

cache.writeData({
  data: {
    isLoggedIn: !!localStorage.getItem("token"),
  },
});

const IS_LOGGED_IN = gql`
  query IsUserLoggedIn {
    isLoggedIn @client
  }
`;

function IsLoggedIn() {
  const { data } = useQuery(IS_LOGGED_IN);
  return data.isLoggedIn ? <AppContext /> : <Login />;
}

const PageControl = () => {
  return (
    <Router>
      <Switch>
        <Route path="/login" exact render={() => <IsLoggedIn />} />
        <Route path="/" exact render={() => <Home />} />
        <Redirect to="/" />
      </Switch>
    </Router>
  );
};

injectStyles();

ReactDOM.render(
  <ApolloProvider client={client}>
    <MuiThemeProvider theme={theme}>
      <AppCrash />
    </MuiThemeProvider>
  </ApolloProvider>,
  document.getElementById("root")
);
